import { render, staticRenderFns } from "./subprogram-nba-school-team-page-summary.vue?vue&type=template&id=171cb86c&scoped=true&"
import script from "./subprogram-nba-school-team-page-summary.vue?vue&type=script&lang=js&"
export * from "./subprogram-nba-school-team-page-summary.vue?vue&type=script&lang=js&"
import style0 from "./subprogram-nba-school-team-page-summary.vue?vue&type=style&index=0&id=171cb86c&lang=scss&scoped=true&"
import style1 from "./subprogram-nba-school-team-page-summary.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171cb86c",
  null
  
)

export default component.exports